import {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {getKYCVerification} from '../../../reducers/user/actions'
import Selector from '../../../selectors/modals/verifications';
import ModalsLib from '../../../lib/modals';
import QRCode from './qrCode';
import BlueButton from '../../components/blue-button';

export default () => {
    const {kyc_profile} = useSelector(Selector),
          dispatch = useDispatch();

    useEffect(() => {
        if(!kyc_profile.verification)
            dispatch(getKYCVerification());
    }, [kyc_profile.verification]);

    return (
        <div className="modal animate__animated animate__fadeInUp animate__faster">
            <div className="modal-header">
                <div className="modal-header-left">
                    <div className="title">Identity Verification</div>
                    <div className="descriptions">Verify your identity to get full access to Lucksy</div>
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>

            {!kyc_profile.verification ? (
                <div className="modal-body">
                    <div className="modal-loader">
                        <div className="element"></div>
                    </div>
                </div>
            ) : (
                <>
                    <div className="modal-body">
                        <QRCode address={kyc_profile.verification.url} />

                        <div className="modal-text">Scan the QR code from your phone or open the link from your device by clicking on the "Open Verification Link" button</div>
                        {/* <div className="modal-text">An amount less than the minimum amount will <b>NOT</b> be credited and is <b>NON</b>-refundable!</div> */}
                
                        {/* <div className="modal-message success">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#0CDA50" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10 12.5L11.5 14L14.75 11" stroke="#0CDA50" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Make deposits using cryptocurrency and get a bonus of 1 to the deposit amount!</span>
                        </div> */}
                    </div>
                    <div className="modal-footer">
                        <BlueButton onClick={e => window.open(kyc_profile.verification.url)}>
                            Open verification link
                        </BlueButton>
                    </div>
                </>
            )}
        </div>
    )
}